import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import { IStateProps } from './model'

import styles from './style.module.scss'

export const View = ({ getDomNode, data, selectedIndex, onSelectIndex }: IStateProps) => (
	<Tabs domRef={getDomNode as any} selectedIndex={selectedIndex} onSelect={onSelectIndex}>
		<TabList className={styles.tabList}>
			{data.map(({ tabTitle }) => (
				<Tab
					tabIndex='0'
					selectedClassName={styles.tabActive}
					className={styles.tab}
					key={`tab-${tabTitle}`}
				>
					{tabTitle}
				</Tab>
			))}
		</TabList>
		<div className={styles.tabPanelList}>
			{data.map(({ tabTitle, TabComponent }) => (
				<TabPanel
					forceRender
					key={`tap-panel-${tabTitle}`}
					className={styles.tabPanel}
					selectedClassName={styles.tabPanelActive}
				>
					<TabComponent data={data} selectedIndex={selectedIndex} onSelectIndex={onSelectIndex} />
				</TabPanel>
			))}
		</div>
	</Tabs>
)
